import { authApi } from './authApi';

// Authentication service with proper error handling
export const authService = {
  // Sign in with email and password
  async signIn(email, password) {
    try {
      const { data, error } = await authApi?.signIn({ email, password });
      return { data, error };
    } catch (error) {
      return { 
        data: null, 
        error: { message: 'Network error. Please check your connection.' } 
      };
    }
  },

  // Sign up with email and password
  async signUp(email, password, userData = {}) {
    try {
      const { data, error } = await authApi?.signUp({
        company_name: userData?.companyName || '',
        first_name: userData?.firstName || '',
        last_name: userData?.lastName || '',
        email,
        password,
        role: userData?.role || 'user'
      });
      return { data, error };
    } catch (error) {
      return { 
        data: null, 
        error: { message: 'Network error. Please check your connection.' } 
      };
    }
  },

  // Get current user via REST using access token
  async getCurrentUser(token) {
    try {
      const { data, error } = await authApi?.me({ token });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: 'Network error. Please check your connection.' }
      };
    }
  },

  // Sign out
  async signOut() {
    try {
      const { data, error } = await authApi.signOut();
      return { data, error };
    } catch (error) {
      return { 
        error: { message: error.message || 'Failed to sign out. Please try again.' } 
      };
    }
  },

  // Get current session
  async getSession() {
    try {
      const { data, error } = await authApi.getSession();
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || 'Failed to get session. Please try again.' }
      };
    }
  },

  // Get user profile data
  async getUserProfile(userId) {
    try {
      const { data, error } = await authApi.getUserProfile({ userId });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || 'Failed to fetch user profile.' }
      };
    }
  },

  // Update user profile
  async updateUserProfile(userId, updates) {
    try {
      const { data, error } = await authApi.updateUserProfile({ userId, updates });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || 'Failed to update profile.' }
      };
    }
  },

  // Reset password
  async resetPassword(email) {
    try {
      const { data, error } = await authApi.resetPassword({ email });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || 'Failed to send password reset email.' }
      };
    }
  },

  // Update password
  async updatePassword(newPassword) {
    try {
      const { data, error } = await authApi.updatePassword({ newPassword });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || 'Failed to update password.' }
      };
    }
  },

  // OAuth sign in
  async signInWithOAuth(provider) {
    try {
      const { data, error } = await authApi.signInWithOAuth({ provider });
      return { data, error };
    } catch (error) {
      return {
        data: null,
        error: { message: error.message || `Failed to sign in with ${provider}.` }
      };
    }
  }
};

export default authService;